import {
  Component, OnInit, OnChanges, ElementRef, Input,
  ViewChild, SimpleChanges, OnDestroy, ViewChildren, QueryList
} from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

import { PerfilAssinaturaService } from '../service/perfil-assinatura.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  Liquidacao, Login, GlobalService, FuncaoService, PerfilAssinatura, EddyAutoComplete, Exercicio, ExercicioService
} from 'eddydata-lib';

@Component({
  selector: 'lib-perfil-assinatura',
  templateUrl: './perfil-assinatura.component.html'
})
export class PerfilAssinaturaComponent implements OnInit, OnChanges, OnDestroy {

  public ptBR: any;
  public entity: PerfilAssinatura;
  public entityTemp: PerfilAssinatura;
  public listaPerfis: Array<any>;
  public exercicioAutoComplete: EddyAutoComplete<Exercicio>;

  protected unsubscribe: Subject<void> = new Subject();

  @Input() lista: Array<any>;
  @Input() entidade: Liquidacao;
  @Input() login: Login;
  @Input() visualizar: boolean;

  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;
  @ViewChildren('btnsEditar') public btnsEditar: QueryList<ElementRef>;

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    private messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected anoService: ExercicioService,
    protected perfilAssinaturaService: PerfilAssinaturaService,
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.listaPerfis = this.lista;
    // autocomplete para exercicio
    this.exercicioAutoComplete = new EddyAutoComplete(null, this.anoService,
      'id', ['ano'], { cidade_id: this.login.cidade.id, orderBy: 'ano' }, { number: ['ano'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lista) {
      this.listaPerfis = this.lista;
    }
  }

  private desabilitarEdicao(desabilitar: boolean) {
    this.btnsEditar.forEach((btn) => btn.nativeElement.disabled = desabilitar)
    this.btnAdicionar.nativeElement.disabled = desabilitar;
  }

  public adicionar() {
    this.entity = new PerfilAssinatura();
    this.entity.orgao = this.entidade;
    this.entity['editavel'] = true;
    this.entity['salvo'] = false;
    if (!this.listaPerfis) {
      this.listaPerfis = new Array();
    }
    this.listaPerfis.unshift(this.entity);
    this.desabilitarEdicao(true);

    setInterval(() => new GlobalService().calendarMascara(), 500)
  }

  public salvar(item: PerfilAssinatura) {
    try {

      if (!item.nome) {
        throw new Error('Informe o nome do perfil de assinatura!')
      }


      item['editavel'] = false;
      item['salvo'] = true;
      this.desabilitarEdicao(false);

    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  public editar(item: PerfilAssinatura) {
    this.entityTemp = JSON.parse(JSON.stringify(item));

    this.entity = item;
    this.entity['editavel'] = true;
    this.entity['salvo'] = true;
    this.desabilitarEdicao(true);
  }

  public cancelar(item: PerfilAssinatura, index: number) {
    if (item['salvo'] && item.id === this.entityTemp?.id) {
      item.nome = this.entityTemp.nome;
      this.entity = item;
      this.entity['editavel'] = false;
    } else {
      this.listaPerfis.splice(index, 1);
    }
    this.desabilitarEdicao(false);
  }

  public confirmarRemocao(item: PerfilAssinatura, index: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja remover este perfil?',
      acceptLabel: "Sim",
      rejectLabel: "Não",
      header: 'Remoção',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.remover(item, index)
      },
    });
  }

  private remover(item: PerfilAssinatura, index: number) {
    if (item.id) {
      this.perfilAssinaturaService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaPerfis.splice(index, 1);
          this.messageService.add({ severity: 'info', summary: 'Exclusão', detail: 'Registro removido com sucesso!' });
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Exclusão', detail: error.error.payload });
          throw error;
        });
    } else {
      this.listaPerfis.splice(index, 1);
    }
  }

  public podeVisualizar() {
    if (this.visualizar === true) {
      return true;
    }
    if (this.visualizar === false) {
      return false;
    }
  }

}


